export default "__VITE_ASSET__DtoQNTMq__"